import ProcessCompleted from '../../../../components/tuitionProcess/ProcessCompleted';

const CompletedNoSua = () => {
  return <ProcessCompleted prefix="tuitionProcessNoSua.completed" />;
};

export default CompletedNoSua;
